/**
 *
 * MobileSso
 *
 * @version 1.0.0
 * @author Elia Minozzi
 * @since 18-Jun-2025
 */

import React from 'react'
import PropTypes from 'prop-types'
import formattedMessage from '../modules/languageModule'
import Toggle from 'Hoc/ToggleComponent'
import MerchantModal from '@nexidigital/merchantmodal'
import appEnvRemap from 'Utility/appEnvRemap'
import { openUrl } from 'Utility/globalMethods'

const GoToNpgSsoModal = props =>
  <Toggle>
    <MerchantModal
      topBarTitle=' '
      title={formattedMessage.attention}
      primaryAction={() => {
        const searchParams = new URLSearchParams(location.search)
        const tenant = decodeURIComponent(searchParams.get('tenant'))
        const providerId = process.env.COMMERCE_WEB_PROVIDER_ID
        console.log(`${appEnvRemap.API_NPG}/oauth2/sso-npg-federation?providerId=${providerId}&tenant=${tenant}`, 'URL SSO NPG')
        openUrl(`${appEnvRemap.API_NPG}/oauth2/sso-npg-federation?providerId=${providerId}&tenant=${tenant}`)
      }}
      primaryButtonLabel={formattedMessage.go}
      description={formattedMessage.goToNpgDescriptionModal}
    />
  </Toggle>

GoToNpgSsoModal.propTypes = {
  // Add here some propTypes
  actions: PropTypes.object
}

GoToNpgSsoModal.defaultProps = {
  // Add here some default propTypes values
  actions: {}
}

export default GoToNpgSsoModal
